import camelCase from 'lodash/camelCase';

export interface IMakeErrorMsgID {
  errorMessages: string[];
  errorMsgIds: string[];
}

export const makeErrorMsgID = (errorMsgs: string[] | string, errorName: string): IMakeErrorMsgID => {
  const errorMessages = Array.isArray(errorMsgs) ? errorMsgs : [errorMsgs];
  const errorMsgIds = errorMessages.map((_, index) => camelCase(`${errorName} error ${index}`));

  return {
    errorMessages,
    errorMsgIds
  };
};
